module.exports = __webpack_public_path__ + "00_hige.b95dd33a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer3/00_hige.png
// module id = DozW
// module chunks = 0